// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1___be7580cc8d667a99b45","cls2":"BulkFollowListModal-cls2___fd0019a9881c4772dfc BulkFollowListModal-cls1___be7580cc8d667a99b45"};